import React from "react";
import { Box, Theme } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { lighten } from "@mui/material/styles";

const useIconStyles = makeStyles<Theme, { bgVariant: "white" | "accent" }>(
  (theme) => ({
    root: (props) => ({
      width: 56,
      height: 56,
      borderRadius: theme.spacing(1.5),
      display: "flex",
      alignItems: "center",
      justifyContent: "center",

      backgroundColor:
        props.bgVariant === "white"
          ? theme.palette.common.white
          : lighten(theme.palette.accent.main, 0.9),

      color: theme.palette.accent.main,

      "& svg": {
        width: 32,
        height: 32,
      },

      "& svg path": {
        fill: `${theme.palette.accent.main} !important`,
        stroke: `${theme.palette.accent.main} !important`,
        strokeWidth: "0.5 !important",
      },
    }),
  }),
);

interface ProfileIconBlockProps {
  icon: React.ReactNode;
  bgVariant?: "white" | "accent";
}

export const ProfileIconBlock: React.FC<ProfileIconBlockProps> = ({
  icon,
  bgVariant = "white",
}) => {
  const s = useIconStyles({ bgVariant });

  return <Box className={s.root}>{icon}</Box>;
};
